exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pulse-period-picker__generate{margin-left:8px}.pulse-picker-toggles{display:flex;align-items:center;gap:20px;margin-top:10px}.pulse-picker-toggle{display:flex;align-items:center;gap:6px;margin:0;font-size:13px;color:#333;cursor:pointer;user-select:none}.pulse-picker-toggle input[type=checkbox]{margin:0;cursor:inherit}", ""]);

// exports
